import React from "react";
import { Box, AppBar, Toolbar, IconButton, Typography, Button, Card, CardContent, CardMedia, Stack, CircularProgress, Link as MuiLink } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link, useNavigate } from "react-router-dom";

import TagpayIcon from "../../assets/tagpay.png";
import WaitingLoader from "../../WaitingLoader/component";

const Tagpay = ({ loader, tagList = [] }) => {
  const navigate = useNavigate();

  const goToTagHistory = (uid) => {
    localStorage.setItem("TagUUID", uid);
    navigate(`/taghistory/${uid}`);
  };

  return (
    <Box sx={{ background: "radial-gradient(circle, rgba(245,233,233,0.4) 0%, rgba(185,245,247,0.34) 100%)", minHeight: "100vh" }}>
      {/* Loader */}
      {loader && <WaitingLoader />}

      {/* ✅ Top Navigation */}
      <AppBar
        position="sticky"
        elevation={0}
        sx={{ backgroundColor: "#FAE14B", color: "#583C43" }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box display="flex" alignItems="center">
            <IconButton component={Link} to="/profile" edge="start" color="inherit">
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" sx={{ ml: 1, fontWeight: 600 }}>
              Tag List
            </Typography>
          </Box>

          <Button
            component={Link}
            to="/addtag"
            variant="contained"
            startIcon={<AddIcon />}
            sx={{
              backgroundColor: "#00B177",
              "&:hover": { backgroundColor: "#009e6b" },
              borderRadius: "20px",
              px: 2,
            }}
          >
            ADD TAG
          </Button>
        </Toolbar>
      </AppBar>

      {/* ✅ Tag Cards */}
      <Box sx={{ px: 2, py: 3 }}>
        {tagList
          .filter((el) => el.active)
          .map((el, index) => (
            <Card
              key={index}
              sx={{
                mb: 3,
                borderRadius: "20px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                backgroundColor: "white",
              }}
            >
              <CardContent>
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                  <Stack direction="row" spacing={2}>
                    <CardMedia
                      component="img"
                      src={TagpayIcon}
                      alt="Tag Icon"
                      sx={{ width: 60, height: 60 }}
                    />
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Payment Method
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Tag ID: {el.uid}
                      </Typography>
                      <Typography variant="h6" sx={{ mt: 0.5, fontWeight: 700 }}>
                        ₹{el.balance}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>

                {/* Buttons */}
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="space-between"
                  sx={{ mt: 2 }}
                >
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => goToTagHistory(el.uid)}
                    sx={{
                      borderRadius: "20px",
                      color: "#00B177",
                      borderColor: "#00B177",
                      textTransform: "none",
                    }}
                  >
                    Recharge
                  </Button>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => goToTagHistory(el.uid)}
                    sx={{
                      borderRadius: "20px",
                      backgroundColor: "#00B177",
                      "&:hover": { backgroundColor: "#009e6b" },
                      textTransform: "none",
                    }}
                  >
                    View
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          ))}

        {/* Recharge Another Tag */}
        <Box textAlign="center" sx={{ mt: 4 }}>
          <Typography variant="body2" color="text.secondary" mb={1}>
            Or
          </Typography>
          <MuiLink
            component={Link}
            to="/TagRecharge"
            underline="none"
            sx={{ color: "#718198", fontWeight: 500, display: "inline-flex", alignItems: "center" }}
          >
            Recharge Another Tag
            <ArrowForwardIosIcon sx={{ fontSize: 14, ml: 0.5 }} />
          </MuiLink>
        </Box>
      </Box>
    </Box>
  );
};

export default Tagpay;
